/**
 * Declarative permission helpers for client-side role checks.
 *
 * Usage:
 *   import { isAdmin, hasRole } from '../utils/permissions.js';
 *   if (isAdmin(user)) { ... }
 *
 * The user object is expected to have a `roles` array — either
 * strings (["admin"]) or objects ({ name: "admin" }).
 */

export const hasRole = (user, roleName) =>
  Array.isArray(user?.roles) && user.roles.some((r) => (typeof r === 'string' ? r : r?.name) === roleName);

export const isAdmin = (user) => hasRole(user, 'admin');
